import SimpleType from './simple-type';

class TelType extends SimpleType {
  /* eslint-disable no-magic-numbers */
  static types = { 1: '自宅', 2: '携帯', 3: '会社', 4: 'その他' };
  /* eslint-enable no-magic-numbers */
  static isCompany = (typeCode) => typeCode && String(typeCode) === '3';
  getTypes () {
    return TelType.types;
  }
  isCompany () {
    const self = this;
    return TelType.isCompany(self.getVal());
  }
}
export default TelType;
